import { render, staticRenderFns } from "./sport_competition_challenge_accepted.vue?vue&type=template&id=3d1571ff&scoped=true&"
import script from "./sport_competition_challenge_accepted.vue?vue&type=script&lang=js&"
export * from "./sport_competition_challenge_accepted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1571ff",
  null
  
)

export default component.exports